exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-6481bf4a] .entrance-chat-empty{height:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}[data-v-6481bf4a] .entrance-chat-empty .empty-container{position:relative;top:-1.33333333rem}[data-v-6481bf4a] .entrance-chat-empty .empty-primary-btn{background:#3a5999;color:#fff;margin-top:.53333333rem;font-size:.37333333rem;width:3.53333333rem;height:.93333333rem;line-height:.93333333rem}", ""]);

// exports
